import { render, staticRenderFns } from "./LanguageBadge.vue?vue&type=template&id=b65aaa72"
import script from "./LanguageBadge.vue?vue&type=script&lang=js"
export * from "./LanguageBadge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports